// 自定义rem设置脚本，移除540px宽度限制
(function(win) {
  var doc = win.document;
  var docEl = doc.documentElement;
  var metaEl = doc.querySelector('meta[name="viewport"]');
  var dpr = 0;
  var tid;

  // 设置viewport，进行缩放，达到高清效果
  if (!metaEl) {
    metaEl = doc.createElement('meta');
    metaEl.setAttribute('name', 'viewport');
    metaEl.setAttribute('content', 'width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no');
    if (docEl.firstElementChild) {
      docEl.firstElementChild.appendChild(metaEl);
    } else {
      var wrap = doc.createElement('div');
      wrap.appendChild(metaEl);
      doc.write(wrap.innerHTML);
    }
  }

  // 设置dpr
  if (!dpr) {
    var isIPhone = win.navigator.appVersion.match(/iphone/gi);
    var devicePixelRatio = win.devicePixelRatio;
    if (isIPhone) {
      // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
      if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
        dpr = 3;
      } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
        dpr = 2;
      } else {
        dpr = 1;
      }
    } else {
      // 其他设备下，仍旧使用1倍的方案
      dpr = 1;
    }
  }

  docEl.setAttribute('data-dpr', dpr);

  // 调整body的font-size，使其作为rem的基础
  if (doc.readyState === 'complete') {
    doc.body.style.fontSize = 12 * dpr + 'px';
  } else {
    doc.addEventListener('DOMContentLoaded', function() {
      doc.body.style.fontSize = 12 * dpr + 'px';
    }, false);
  }

  // 核心函数，动态设置html的font-size
  function refreshRem() {
    var width = docEl.getBoundingClientRect().width;
    // 移除540px的宽度限制，支持高分辨率屏幕
    // if (width / dpr > 540) {
    //   width = 540 * dpr;
    // }
    
    // 根据屏幕宽度计算rem值
    // 这里使用1920px作为设计稿基准，所以将屏幕宽度除以100
    // 这样1920px屏幕下，1rem = 19.2px，100rem = 1920px
    var rem = width / 100;
    docEl.style.fontSize = rem + 'px';
  }

  // 监听窗口大小变化和页面显示事件，重新计算rem
  win.addEventListener('resize', function() {
    clearTimeout(tid);
    tid = setTimeout(refreshRem, 300);
  }, false);
  win.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      clearTimeout(tid);
      tid = setTimeout(refreshRem, 300);
    }
  }, false);

  // 初始化
  refreshRem();

})(window);